import React, { useCallback, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { differenceInYears } from 'date-fns';
import { AnimatedContainer, ButtonLoadingForm, FormContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import { useUser } from '../../../hooks/user';
import Input from '../../../components/Input';
import getValidationErrors from '../../../utils/getValidationErrors';

interface formProps {
  name: string;
  lastName: string;
  birthDate: string;
}

export const UserData: React.FC<ComponentUserRegisterProps> = ({
  nextPage,
}) => {
  const formRef = useRef<FormHandles>(null);
  const [btnIsLoading, setBtnIsLoading] = useState<boolean>(false);

  const { setUser } = useUser();

  const handleNext = useCallback(async () => {
    const data = formRef?.current?.getData() as formProps;

    try {
      setBtnIsLoading(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('O nome é obrigatório'),
        lastName: Yup.string().required('O nome é obrigatório'),
        birthDate: Yup.string()
          .required('Data de nascimento obrigatória')
          .test(
            'is-18',
            'Você deve ter pelo menos 18 anos',
            value => differenceInYears(new Date(), new Date(value || 0)) >= 18,
          ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      setUser(prev => ({
        ...prev,
        name: `${data.name} ${data.lastName}`,
        birthDate: data.birthDate,
      }));
      nextPage();
    } catch (err) {
      setBtnIsLoading(false);

      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }
    }
  }, [setUser, nextPage]);

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={1} titles={stepLabels} />

      <h1>Dados do Usuário</h1>

      <FormContainer>
        <p>Preencha os espaços abaixo com as informações do CINCO</p>

        <Form ref={formRef} onSubmit={handleNext}>
          <Input name="name" label="Nome" isRequired />
          <Input name="lastName" label="Sobrenome" isRequired />
          <Input
            name="birthDate"
            label="Data de Nascimento"
            type="date"
            isRequired
          />
        </Form>
      </FormContainer>

      <ButtonLoadingForm
        isLoading={btnIsLoading}
        btnType="darkBlue"
        onClick={handleNext}
      >
        Próximo
      </ButtonLoadingForm>
    </AnimatedContainer>
  );
};
